import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Steps } from 'hljd'
import { HeaderView } from '@merchant-backend/common-components'
import styles from './style.module.less'
import Store from './store'
import InfoData from './InfoData'
import RealnameAuthentication from './RealnameAuthentication'
const { Step } = Steps

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
  }

  render() {
    const { currentStep } = this.store

    return (
      <HeaderView>
        <div className={styles.step}>
          <Steps current={currentStep} size="small">
            <Step title="完善信息" />
            <Step title="团队认证" />
          </Steps>
        </div>

        {currentStep == 0 && (
          <InfoData indexStore={this.store} fromCreat={true} />
        )}

        {currentStep == 1 && <RealnameAuthentication indexStore={this.store} />}
      </HeaderView>
    )
  }
}
